/* IZEZE bundle — "Completează rutina": recalculate total + add selected items to cart */
(function () {
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
  }
  function setup(root) {
    if (root.dataset.izInit) return;
    root.dataset.izInit = '1';
    var boxes = Array.prototype.slice.call(root.querySelectorAll('.izeze-bundle__cb'));
    var totalEl = root.querySelector('[data-bundle-total]');
    var btn = root.querySelector('[data-bundle-add]');

    var origEl = root.querySelector('[data-bundle-orig]');
    var saveEl = root.querySelector('[data-bundle-save]');
    function recalc() {
      var sum = 0, count = 0;
      boxes.forEach(function (b) { if (b.checked) { sum += parseInt(b.dataset.price, 10) || 0; count++; } });
      var discount = count >= 2 ? count * 1000 : 0; /* 10 lei = 1000 bani per produs */
      var fin = sum - discount;
      if (totalEl) totalEl.textContent = money(fin);
      if (origEl) origEl.textContent = discount > 0 ? money(sum) : '';
      if (saveEl) saveEl.textContent = discount > 0 ? ('Economisești ' + money(discount) + ' în pachet') : '';
      if (btn) btn.disabled = count === 0;
    }
    boxes.forEach(function (b) {
      b.addEventListener('change', function () {
        var item = b.closest('.izeze-bundle__item');
        if (item) item.classList.toggle('is-off', !b.checked);
        recalc();
      });
    });

    btn && btn.addEventListener('click', function () {
      var items = boxes.filter(function (b) { return b.checked; })
        .map(function (b) { return { id: parseInt(b.dataset.vid, 10), quantity: 1 }; });
      if (!items.length) return;
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Se adaugă…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () {
          // refresh Dawn cart drawer if present, else go to cart
          if (typeof window.routes !== 'undefined') { window.location = '/cart'; }
          else { window.location = '/cart'; }
        })
        .catch(function () { btn.disabled = false; btn.textContent = orig; alert('A apărut o eroare. Încearcă din nou.'); });
    });

    recalc();
  }
  function init() { document.querySelectorAll('[data-bundle]').forEach(setup); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
